import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { useAuth } from '../../../context/AuthContext'
import { fileSrc } from '../../../component/FileLoader'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function UserProfile() {
  const { currentUser, logout } = useAuth()
  const { t } = useTranslation()

  return (
    <Menu as='div' className='relative inline-block text-left'>
      <div>
        <MenuButton className='inline-flex w-full justify-center gap-x-1.5 rounded-md bg-transparent px-3 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-100'>
          <div className='relative inline-flex items-center'>
            <div className='w-[2.375rem] h-[2.375rem] inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-full border border-transparent text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none '>
              <img
                className='inline-block size-[38px] rounded-full ring-2 ring-white '
                src={
                  currentUser.file ?
                    fileSrc(currentUser.file) : currentUser?.google_picture ?
                      currentUser?.google_picture
                      : 'https://i.pinimg.com/originals/c0/27/be/c027bec07c2dc08b9df60921dfd539bd.webp'
                }
                alt={t('Image Description')}
              ></img>
            </div>
            <div className='ms-3 hidden sm:block'>
              <h3
                style={{
                  fontFamily: 'Inter',
                  fontSize: '12px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '16px' /* 133.333% */,
                  letterSpacing: '0.4px'
                }}
                className='font-semibold text-left text-gray-800 '
              >
                {currentUser?.firstname} {currentUser?.lastname}
              </h3>
              <p
                style={{
                  fontFamily: 'Inter',
                  fontSize: '10px',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: '16px' /* 160% */,
                  letterSpacing: '1.5px',
                  textTransform: 'uppercase'
                }}
                className='text-sm font-medium text-gray-400'
              >
                {currentUser?.email}
              </p>
            </div>
          </div>
        </MenuButton>
      </div>

      <MenuItems
        transition
        className='absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in'
      >
        <div className='py-1'>
          <MenuItem>
            <Link
              to='/profile'
              className='flex gap-x-2 px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 20 20'
                fill='currentColor'
                className='size-5'
              >
                <path
                  fillRule='evenodd'
                  d='M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-5.5-2.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM10 12a5.99 5.99 0 0 0-4.793 2.39A6.483 6.483 0 0 0 10 16.5a6.483 6.483 0 0 0 4.793-2.11A5.99 5.99 0 0 0 10 12Z'
                  clipRule='evenodd'
                />
              </svg>
              {t('Profile')}
            </Link>
          </MenuItem>
        </div>
        <div className='py-1'>
          <MenuItem>
            <div
              className='flex gap-x-2 px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none'
              onClick={logout}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 20 20'
                fill='currentColor'
                className='size-5'
              >
                <path
                  fillRule='evenodd'
                  d='M3 4.25A2.25 2.25 0 0 1 5.25 2h5.5A2.25 2.25 0 0 1 13 4.25v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 0-.75-.75h-5.5a.75.75 0 0 0-.75.75v11.5c0 .414.336.75.75.75h5.5a.75.75 0 0 0 .75-.75v-2a.75.75 0 0 1 1.5 0v2A2.25 2.25 0 0 1 10.75 18h-5.5A2.25 2.25 0 0 1 3 15.75V4.25Z'
                  clipRule='evenodd'
                />
                <path
                  fillRule='evenodd'
                  d='M6 10a.75.75 0 0 1 .75-.75h9.546l-1.048-.943a.75.75 0 1 1 1.004-1.114l2.5 2.25a.75.75 0 0 1 0 1.114l-2.5 2.25a.75.75 0 1 1-1.004-1.114l1.048-.943H6.75A.75.75 0 0 1 6 10Z'
                  clipRule='evenodd'
                />
              </svg>
              {t('Log Out')}
            </div>
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  )
}
